export class TimePlanversionEvent {
    timeLineIndex: number;
    historicPlan: boolean;
}